import React, { useCallback, useState } from 'react';
import { Modal } from 'antd';

import {
  ReportDataProfileContainer,
  BoxReportItens,
  ReportItem,
  BoxButton,
} from './style';

import { dataKeys } from './data/descriptions';
import ButtonBase from '~/components/Button';
import { filterResponses, responseBoolean } from './data/filterResponses';
import { getItens, getItensDiagnostico, getSubItens } from './data/getItens';

function createInnerHtml(texto) {
  return { __html: texto };
}

const ReportDataProfile = ({
  onSubmit,
  dadosPerfil,
  showProfileResume,
  setShowProfileResume,
  campObrigatorio = false,
  atendimentoEmergencia = false,
  emergenciaEspecializada = false,
  estratificacaoRiscoEmergencia = false,
  leitosEmergencia = false,
  pacienteEmergencia = false,
  redeAssistencial = false,
  sistemasComputadorizados = false,
}) => {
  const submitProfile = useCallback(() => {
    setShowProfileResume(false);
    setTimeout(() => {
      onSubmit(dadosPerfil);
    }, 500);
  }, []);

  function validarEmergencia(dados) {

    if (dados?.possuiUnidadeDeEmergencia === true && typeof dados?.atendimentoEmergencia[0] === "undefined") {
      atendimentoEmergencia = true;
      campObrigatorio = true;
    }
    if (dados?.possuiEmergenciaEspecializada === true && dados?.emergenciaEspecializada.length === 0 && dados?.outrosEmergenciaEspecializada === false) {
      emergenciaEspecializada = true;
      campObrigatorio = true;
    }
    if (dados?.estratificacaoDeRiscoNaEmergencia === true && dados?.estratificacoesDeRisco.length === 0 && dados?.outrosEstratificacoesDeRisco === false) {
      estratificacaoRiscoEmergencia = true;
      campObrigatorio = true;
    }
    if (dados?.possuiUnidadeDeEmergencia === true && dados.totalDeLietosEmergencia <= 0) {
      leitosEmergencia = true;
      campObrigatorio = true;
    }
    if (dados?.possuiUnidadeDeEmergencia === true && (dados.atendeEmergenciaAdulto === false && dados.atendeEmergenciaPediatrico === false)) {
      pacienteEmergencia = true;
      campObrigatorio = true;
    }
    validarCamposObrigatorios(atendimentoEmergencia, emergenciaEspecializada, estratificacaoRiscoEmergencia, leitosEmergencia, pacienteEmergencia);

  }

  function validarCamposObrigatorios(atendimentoEmergencia, emergenciaEspecializada, estratificacaoRiscoEmergencia, leitosEmergencia,
     pacienteEmergencia, redeAssistencial, sistemasComputadorizados) {

    if (atendimentoEmergencia === false &&
      emergenciaEspecializada === false &&
      estratificacaoRiscoEmergencia === false &&
      leitosEmergencia === false &&
      pacienteEmergencia === false &&
      redeAssistencial === false &&
      sistemasComputadorizados === false) {
      campObrigatorio = false;
    }

  }

  function validaRedeAssitencial(dados){

    if(dados?.redeAssistencial === true && dados?.redeAssistencialCnpj === "" || dados?.redeAssistencialRazao === "ESTE CNPJ NÃO É VÁLIDO NA RECEITA FEDERAL" ){
      redeAssistencial = true;
      campObrigatorio = true;
    }

    validarCamposObrigatorios(redeAssistencial);
   

  }

  function validaSistemasComputadorizados(dados){
    if (dados?.usaProntuarioSistemaInformatizado === true) {
       if (dados?.sistemaInformatizadoProntuario.length === 0) {
        sistemasComputadorizados = true;
        campObrigatorio = true;
      }else
      if (dados?.sistemaInformatizadoProntuario.length > 0 && dados?.sistemasEletronicosHospital.length < 2 ) {
        sistemasComputadorizados = true;
        campObrigatorio = true;
      }

    } 

    validarCamposObrigatorios(sistemasComputadorizados);
  }

  return (
    <ReportDataProfileContainer>
      <Modal
        title="Confira os dados antes de submeter"
        centered
        visible={showProfileResume}
        onOk={() => setShowProfileResume(false)}
        onCancel={() => setShowProfileResume(false)}
        width={800}
        footer={false}
      >
        <BoxReportItens>
          {/* 1. Qual o tipo de estabelecimento? */}
          <ReportItem>
            <h3>1. Qual o tipo de estabelecimento?</h3>

            <p>
              {dadosPerfil?.tipoHospital
                ? dataKeys?.tipoHospital?.opcoes[dadosPerfil?.tipoHospital]
                  ?.resposta
                : ''}
            </p>

            {dadosPerfil?.tipoHospital === 'e' && (
              <div className="subItens">
                <h3>Se especializado, em qual área? </h3>

                <div>
                  {getSubItens(
                    'tipoHospital',
                    dadosPerfil?.tipoHospital,
                    dadosPerfil?.tipoEstabelecimento
                  )
                    ?.sort((a, b) => (a?.posicao > b?.posicao ? 1 : -1))
                    ?.map((item, index) => (
                      <p key={`${item?.nome}-${index}`}> - {item?.nome}</p>
                    ))}
                </div>

                {dadosPerfil?.outroTipoHospital && (
                  <div>
                    <p> - Outro {dadosPerfil?.outroTipoHospital}</p>
                  </div>
                )}
              </div>
            )}
          </ReportItem>
          {/* ./ 1. Qual o tipo de estabelecimento? */}

          {/* 2. Qual o número de leitos da instituição? */}
          <ReportItem>
            <h3>2. Qual o número de leitos da instituição?</h3>

            <p>
              {' '}
              {dadosPerfil?.numeroDeLeitos ? dadosPerfil?.numeroDeLeitos : ''}
            </p>
          </ReportItem>
          {/* ./ 2. Qual o número de leitos da instituição? */}

          {/*3. Qual o perfil etário de pacientes atendidos pela instituição? */}
          <ReportItem>
            <h3>
              3. Qual o perfil etário de pacientes atendidos pela instituição?
            </h3>

            {getItens('perfilEtario', dadosPerfil?.perfilEtario)
              ?.sort((a, b) => (a?.posicao > b?.posicao ? 1 : -1))
              ?.map((item, index) => (
                <p key={`${item.nome}-${index}`}> - {item.nome}</p>
              ))}
          </ReportItem>
          {/* ./3. Qual o perfil etário de pacientes atendidos pela instituição? */}

          {/*4. Quais os perfis de internação hospitalar? */}
          <ReportItem>
            <h3>4. Quais os perfis de internação hospitalar?</h3>

            {getItens(
              'perfilInternacaoHospitalar',
              dadosPerfil?.perfilInternacaoHospitalar
            )
              ?.sort((a, b) => (a?.posicao > b?.posicao ? 1 : -1))
              ?.map((item, index) => (
                <p key={`${item?.nome}-${index}`}> - {item?.nome}</p>
              ))}
          </ReportItem>
          {/* ./4. Quais os perfis de internação hospitalar? */}

          {/*5. O hospital realiza procedimentos cirúrgicos? ( não inclui procedimentos endoscópicos)? */}
          <ReportItem>
            <h3>5. O hospital realiza procedimentos cirúrgicos? (não inclui procedimentos endoscópicos)?</h3>

            {dadosPerfil?.procedimentosCirurgicos !== null &&
              responseBoolean(dadosPerfil?.procedimentosCirurgicos)}
          </ReportItem>
          {/* ./5. O hospital realiza procedimentos cirúrgicos? ( não inclui procedimentos endoscópicos)? */}

          {/*6. Como é a relação do corpo clínico do hospital? */}
          <ReportItem>
            <h3>6. Como é a relação do corpo clínico do hospital?</h3>

            {dadosPerfil?.corpoClinicoHospital &&
              filterResponses(
                'corpoClinicoHospital',
                dadosPerfil?.corpoClinicoHospital
              )}
          </ReportItem>
          {/* ./6. Como é a relação do corpo clínico do hospital? */}

          {/*7. A instituição é um hospital de ensino? */}
          <ReportItem>
            <h3>7. A instituição é um hospital de ensino?</h3>

            {dadosPerfil?.instituicaoDeEnsino !== null &&
              responseBoolean(dadosPerfil?.instituicaoDeEnsino)}
          </ReportItem>
          {/* ./7. A instituição é um hospital de ensino? */}

          {/*8. A instituição possui programa de residência? */}
          <ReportItem>
            <h3>8. A instituição possui programa de residência?</h3>

            {dadosPerfil?.programaDeResidencia !== null &&
              responseBoolean(dadosPerfil?.programaDeResidencia)}
          </ReportItem>
          {/* ./8. A instituição possui programa de residência? */}

          {/*9. Total de médicos(as) que atuam na instituição */}
          <ReportItem>
            <h3>9. Total de médicos(as) que atuam na instituição:</h3>

            <p>{dadosPerfil?.totalDeMedicos && dadosPerfil?.totalDeMedicos}</p>
          </ReportItem>
          {/* ./9. Total de médicos(as) que atuam na instituição */}

          {/*10. Total de enfermeiros(as) que atuam na instituição */}
          <ReportItem>
            <h3>10. Total de enfermeiros(as) que atuam na instituição:</h3>

            <p>
              {dadosPerfil?.totalDeEnfermeiros &&
                dadosPerfil?.totalDeEnfermeiros}
            </p>
          </ReportItem>
          {/* ./10. Total de enfermeiros(as) que atuam na instituição */}

          {/*11. Total de técnicos(as) de enfermagem que atuam na instituição */}
          <ReportItem>
            <h3>
              11. Total de técnicos(as) de enfermagem que atuam na instituição:
            </h3>

            <p>
              {dadosPerfil?.totalDeTecnicos && dadosPerfil?.totalDeTecnicos}
            </p>
          </ReportItem>
          {/* ./11. Total de técnicos(as) de enfermagem que atuam na instituição */}

          {/*12. Total de funcionários(as) ativos(as) que atuam na instituição  */}
          <ReportItem>
            <h3>
              12. Total de funcionários(as) ativos(as) que atuam na instituição
              (considerar assistenciais e administrativos, exceto
              terceirizados):
            </h3>

            <p>
              {dadosPerfil?.totalDeEmpregados && dadosPerfil?.totalDeEmpregados}
            </p>
          </ReportItem>
          {/* ./12. Total de funcionários(as) ativos(as) que atuam na instituição  */}

          {/*13. A instituição acompanha a métrica Net Promoter Score (NPS)?  */}
          <ReportItem>
            <h3>
              13. A instituição acompanha a métrica Net Promoter Score (NPS)?
            </h3>

            {responseBoolean(dadosPerfil?.metricaNPS)}

            {dadosPerfil?.metricaNPS && (
              <div className="subItens">
                <h3>Se sim, qual a nota no último ano? </h3>
                <p>{dadosPerfil?.ultimaPontuacaoNPS}</p>
              </div>
            )}
          </ReportItem>
          {/* ./13. A instituição acompanha a métrica Net Promoter Score (NPS)?  */}

          {/*14. A instituição faz uso da metodologia Diagnosis Related Groups (DRGs)?  */}
          <ReportItem>
            <h3>
              14. A instituição faz uso da metodologia Diagnosis Related Groups
              (DRGs)?
            </h3>
            {responseBoolean(dadosPerfil?.usoDRG)}
          </ReportItem>
          {/* ./14. A instituição faz uso da metodologia Diagnosis Related Groups (DRGs)?  */}

          {/* 15. A instituição faz uso de protocolos institucionais? */}
          <ReportItem>
            <h3>15. A instituição faz uso de protocolos institucionais?</h3>

            {responseBoolean(dadosPerfil?.usoProtocolosClinicosInstitucionais)}

            {dadosPerfil?.usoProtocolosClinicosInstitucionais && (
              <div className="subItens">
                <h3>Se sim, quais?</h3>

                <div>
                  {getItens(
                    'usoProtocolosClinicosInstitucionais',
                    dadosPerfil?.protocolosClinicosInstitucionais
                  )
                    ?.sort((a, b) => (a?.posicao > b?.posicao ? 1 : -1))
                    ?.map((item, index) => (
                      <p key={`${item?.nome}-${index}`}> - {item?.nome}</p>
                    ))}
                </div>
              </div>
            )}
          </ReportItem>
          {/* ./ 15. A instituição faz uso de protocolos institucionais? */}

          {/* 16. A instituição faz uso de prontuário eletrônico ou sistema informatizado? */}
          <ReportItem>
            {validaSistemasComputadorizados(dadosPerfil)}
            {sistemasComputadorizados === true ? (
              <h3><span style={{ color: 'red' }}>16. A instituição faz uso de prontuário eletrônico ou sistema
              informatizado?</span></h3>
            ) : (<h3>16. A instituição faz uso de prontuário eletrônico ou sistema
              informatizado?</h3>)
            }
            
            {responseBoolean(dadosPerfil?.usaProntuarioSistemaInformatizado)}

            {dadosPerfil?.usaProntuarioSistemaInformatizado && (
              <div className="subItens">
                <h3>Se sim, quais?</h3>

                <div>
                  {getItens(
                    'usaProntuarioSistemaInformatizado',
                    dadosPerfil?.sistemaInformatizadoProntuario
                  )
                    ?.sort((a, b) => (a?.posicao > b?.posicao ? 1 : -1))
                    ?.map((item, index) => (
                      <p key={`${item?.nome}-${index}`}> - {item?.nome}</p>
                    ))}
                </div>
                <div>
                  <h3>Informe quais sistemas eletrônicos o hospital utiliza.</h3>
                  {dadosPerfil?.sistemasEletronicosHospital && (
                    <p>{dadosPerfil?.sistemasEletronicosHospital}</p>
                  )}
                </div>
              </div>
            )}
          </ReportItem>
          {/* ./ 15. A instituição faz uso de prontuário eletrônico ou sistema informatizado? */}

          {/* 17. O hospital participa de algum programa de avaliação de qualidade por meio de indicadores? */}
          <ReportItem>
            <h3>
              17. O hospital participa de algum programa de avaliação de
              qualidade por meio de indicadores?
            </h3>

            {responseBoolean(
              dadosPerfil?.usaProgramaAvaliacaoIndicadoresHospitalar
            )}

            {dadosPerfil?.usaProgramaAvaliacaoIndicadoresHospitalar && (
              <div className="subItens">
                <h3>Se sim, quais?</h3>

                <div>
                  {getItens(
                    'usaProgramaAvaliacaoIndicadoresHospitalar',
                    dadosPerfil?.sistemaInformatizadoAvaliacao
                  )
                    ?.sort((a, b) => (a?.posicao > b?.posicao ? 1 : -1))
                    ?.map((item, index) => (
                      <p key={`${item?.nome}-${index}`}> - {item?.nome}</p>
                    ))}
                </div>
                {dadosPerfil?.outrosAvaliacaoIndicadoresHospitalar && (
                  <div>
                    <p> - Outro</p>
                  </div>
                )}
              </div>
            )}
          </ReportItem>
          {/* ./ 17. O hospital participa de algum programa de avaliação de qualidade por meio de indicadores? */}

          {/* 18. A instituição é acreditada/certificada por algum programa?  */}
          <ReportItem>
            <h3>
              18. A instituição é acreditada/certificada por algum programa?
            </h3>

            {responseBoolean(dadosPerfil?.usaCertificadoPrograma)}

            {dadosPerfil?.usaCertificadoPrograma && (
              <div className="subItens">
                <h3>Se sim, quais?</h3>

                <div>
                  {getItens(
                    'usaCertificadoPrograma',
                    dadosPerfil?.certificadoPrograma
                  )
                    ?.sort((a, b) => (a?.posicao > b?.posicao ? 1 : -1))
                    ?.map((item, index) => {
                      const innerHtml = (
                        <span
                          dangerouslySetInnerHTML={createInnerHtml(item?.nome)}
                        />
                      );
                      return (
                        <p key={`${item?.nome}-${index}`}> - {innerHtml}</p>
                      );
                    })}
                </div>
                {dadosPerfil?.outrosCertificadoPrograma && (
                  <div>
                    <p> - Outro</p>
                  </div>
                )}
              </div>
            )}
          </ReportItem>
          {/* ./ 18. A instituição é acreditada/certificada por algum programa?  */}

          {/*19. A instituição faz busca ativa de pacientes para o monitoramento de indicadores?  */}
          <ReportItem>
            <h3>
              19. A instituição faz busca ativa de pacientes para o
              monitoramento de indicadores?
            </h3>
            {responseBoolean(dadosPerfil?.monitoramentoDeIndicadores)}
          </ReportItem>
          {/* ./19. A instituição faz busca ativa de pacientes para o monitoramento de indicadores?  */}

          {/*20. A instituição participa/coordena estudos clínicos?  */}
          <ReportItem>
            <h3>20. A instituição participa/coordena estudos clínicos?</h3>
            {responseBoolean(dadosPerfil?.coordenaEstudosClinicos)}
          </ReportItem>
          {/* ./20. A instituição participa/coordena estudos clínicos?  */}

          {/*21. Possui Unidade de Emergência?  */}
          <ReportItem>
            <h3>21. Possui Unidade de Emergência?</h3>
            {responseBoolean(dadosPerfil?.possuiUnidadeDeEmergencia)
            }
            {validarEmergencia(dadosPerfil)}
          </ReportItem>
          {/* ./21. Possui Unidade de Emergência?  */}

          {/*22. Atendimento da emergência  */}
          <ReportItem>
            {atendimentoEmergencia === true ? (
              <h3><span style={{ color: 'red' }}>22. Atendimento da emergência</span></h3>
            ) : (<h3>22. Atendimento da emergência</h3>)
            }

            <div>
              {getItens(
                'atendimentoEmergencia',
                dadosPerfil?.atendimentoEmergencia
              )
                ?.sort((a, b) => (a?.posicao > b?.posicao ? 1 : -1))
                ?.map((item, index) => (
                  <p key={`${item.nome}-${index}`}> - {item.nome}</p>
                ))}
            </div>
          </ReportItem>
          {/* ./21. Atendimento da emergência  */}

          {/* 23. Possui emergência especializada?  */}
          <ReportItem>
            {emergenciaEspecializada === true ? (
              <h3><span style={{ color: 'red' }}>23. Possui emergência especializada?</span></h3>
            ) : (<h3>23. Possui emergência especializada?</h3>)
            }

            {responseBoolean(dadosPerfil?.possuiEmergenciaEspecializada)}

            {dadosPerfil?.possuiEmergenciaEspecializada && (
              <div className="subItens">
                {emergenciaEspecializada === true && (
                  <h3>Se sim, quais?</h3>
                )}
                <div>
                  {getItens(
                    'possuiEmergenciaEspecializada',
                    dadosPerfil?.emergenciaEspecializada
                  )
                    ?.sort((a, b) => (a?.posicao > b?.posicao ? 1 : -1))
                    ?.map((item, index) => {
                      const innerHtml = (
                        <span
                          dangerouslySetInnerHTML={createInnerHtml(item.nome)}
                        />
                      );
                      return (
                        <p key={`${item.nome}-${index}`}> - {innerHtml}</p>
                      );
                    })}
                </div>

                {dadosPerfil?.outrosEmergenciaEspecializada && (
                  <div>
                    <p> - Outro </p>
                  </div>
                )}
              </div>
            )}
          </ReportItem>
          {/* ./ 22. Possui emergência especializada?  */}

          {/* 24. Utiliza protocolo de estratificação de risco na emergência?  */}
          <ReportItem>
            {estratificacaoRiscoEmergencia === true ? (

              <h3><span style={{ color: 'red' }}>24. Utiliza protocolo de estratificação de risco na emergência?</span></h3>
            ) : (<h3>24. Utiliza protocolo de estratificação de risco na emergência?</h3>)
            }

            {responseBoolean(dadosPerfil?.estratificacaoDeRiscoNaEmergencia)}

            {dadosPerfil?.estratificacaoDeRiscoNaEmergencia && (
              <div className="subItens">
                {estratificacaoRiscoEmergencia === true && (
                  <h3>Se sim, quais?</h3>
                )}

                <div>
                  {getItens(
                    'estratificacaoDeRiscoNaEmergencia',
                    dadosPerfil?.estratificacoesDeRisco
                  )
                    ?.sort((a, b) => (a?.posicao > b?.posicao ? 1 : -1))
                    ?.map((item, index) => {
                      const innerHtml = (
                        <span
                          dangerouslySetInnerHTML={createInnerHtml(item.nome)}
                        />
                      );
                      return (
                        <div key={`${item.nome}-${index}`}>
                          <p> - {innerHtml}</p>
                          {item ===
                            'Modelo Australiano - <i>Australian Triage Scale (ATS)</i>' &&
                            dadosPerfil?.estratificacaoRiscoAtsTipo !==
                            null && (
                              <div
                                style={{
                                  marginLeft: '20px',
                                  marginBottom: '10px',
                                }}
                              >
                                {filterResponses(
                                  'estratificacoesDeRisco',
                                  dadosPerfil?.estratificacaoRiscoAtsTipo
                                )}
                              </div>
                            )}

                          {item ===
                            'Modelo Canadense - <i>Canadian Triage and Acuity Scale (CTAS)</i>' &&
                            dadosPerfil?.estratificacaoRiscoCtasTipo !==
                            null && (
                              <div
                                style={{
                                  marginLeft: '20px',
                                  marginBottom: '10px',
                                }}
                              >
                                {filterResponses(
                                  'estratificacoesDeRisco',
                                  dadosPerfil?.estratificacaoRiscoCtasTipo
                                )}
                              </div>
                            )}

                          {item ===
                            'Modelo de Manchester - <i>Manchester Triage System (MTS)</i>' &&
                            dadosPerfil?.estratificacaoRiscoMtsTipo !==
                            null && (
                              <div
                                style={{
                                  marginLeft: '20px',
                                  marginBottom: '10px',
                                }}
                              >
                                {filterResponses(
                                  'estratificacoesDeRisco',
                                  dadosPerfil?.estratificacaoRiscoMtsTipo
                                )}
                              </div>
                            )}

                          {item ===
                            'Modelo Americano -<i> Emergency Severity Index (ESI)</i>' &&
                            dadosPerfil?.estratificacaoRiscoEsiTipo !==
                            null && (
                              <div
                                style={{
                                  marginLeft: '20px',
                                  marginBottom: '10px',
                                }}
                              >
                                {filterResponses(
                                  'estratificacoesDeRisco',
                                  dadosPerfil?.estratificacaoRiscoEsiTipo
                                )}
                              </div>
                            )}
                        </div>
                      );
                    })}
                </div>

                {dadosPerfil?.outrosEstratificacoesDeRisco && (
                  <div>
                    <p> - Outro</p>
                  </div>
                )}
              </div>
            )}
          </ReportItem>
          {/* ./ 23. Utiliza protocolo de estratificação de risco na emergência?  */}

          {/*25. Atende pacientes adultos na emergência?  */}
          <ReportItem>
            {pacienteEmergencia === true ? (
              <h3><span style={{ color: 'red' }}>25. Atende pacientes adultos na emergência?</span></h3>
            ) : (<h3>25. Atende pacientes adultos na emergência?</h3>)}
            {responseBoolean(dadosPerfil?.atendeEmergenciaAdulto)}
          </ReportItem>
          {/* ./24. Atende pacientes adultos na emergência?  */}

          {/*26. Atende pacientes pediátricos na emergência?  */}
          <ReportItem>
            {pacienteEmergencia === true ? (
              <h3><span style={{ color: 'red' }}>26. Atende pacientes pediátricos na emergência?</span></h3>
            ) : (<h3>26. Atende pacientes pediátricos na emergência?</h3>)}
            {responseBoolean(dadosPerfil?.atendeEmergenciaPediatrico)}
          </ReportItem>
          {/* ./25. Atende pacientes pediátricos na emergência?  */}

          {/*27. Total de leitos na(s) emergência(s):   */}
          <ReportItem>
            {leitosEmergencia === true ? (
              <h3><span style={{ color: 'red' }}>27. Total de leitos na(s) emergência(s):</span></h3>
            ) : (<h3>27. Total de leitos na(s) emergência(s):</h3>)}
            {dadosPerfil?.totalDeLietosEmergencia && (
              <p>{dadosPerfil?.totalDeLietosEmergencia}</p>
            )}
          </ReportItem>
          {/* ./26. Total de leitos na(s) emergência(s):   */}

          {/*28. Possui Time de Resposta Rápida (TRR) ou equivalente?  */}
          <ReportItem>
            <h3>28. Possui Time de Resposta Rápida (TRR) ou equivalente?</h3>
            {responseBoolean(dadosPerfil?.timeDeRespostaRapida)}
          </ReportItem>
          {/* ./28. Possui Time de Resposta Rápida (TRR) ou equivalente?  */}

          {/* 29. Unidades presentes na Instituição:  */}
          <ReportItem>
            <h3>29. Unidades presentes na Instituição:</h3>

            <div className="subItens">
              {dadosPerfil?.possuiUnidadeCoronariana && (
                <p> - Unidade Coronariana</p>
              )}
              {/*  */}

              {dadosPerfil?.possuiUnidadeInternacaoCirurgica && (
                <p> - Unidade de Internação - Cirúrgica</p>
              )}
              {/*  */}

              {dadosPerfil?.possuiUnidadeInternacaoClinicaMedica && (
                <p> - Unidade de Internação - Clínica médica</p>
              )}
              {/*  */}

              {dadosPerfil?.possuiUnidadeInternacaoObstetricaNeonatal && (
                <p> - Unidade de Internação - Obstétrica e Neonatal</p>
              )}
              {/*  */}

              {dadosPerfil?.possuiUnidadeInternacaoPediatrica && (
                <p> - Unidade de Internação - Pediatrica</p>
              )}
              {/*  */}

              {dadosPerfil?.possuiUnidadeInternacaoTraumatoOrtopedica && (
                <p> - Unidade de Internação - Traumato-ortopédica </p>
              )}
              {/*  */}

              {dadosPerfil?.possuiUnidadeAVC && (
                <div>
                  <p> - Unidade de AVC/Vascular</p>
                  {dadosPerfil?.terapiaFibrinolitica !== null && (
                    <div style={{ marginLeft: '20px', marginBottom: '10px' }}>
                      <h3>Realiza terapia fibrinolítica (ex.: trombólise)?</h3>
                      {responseBoolean(dadosPerfil?.terapiaFibrinolitica)}
                    </div>
                  )}

                  {dadosPerfil?.trombectomia !== null && (
                    <div style={{ marginLeft: '20px', marginBottom: '10px' }}>
                      <h3>Realiza trombectomia?</h3>
                      {responseBoolean(dadosPerfil?.trombectomia)}
                    </div>
                  )}
                </div>
              )}
              {/*  */}

              {dadosPerfil?.unidadeSemiIntensiva && (
                <p> - Unidade intermediária/semi-intensiva </p>
              )}
              {/*  */}

              {dadosPerfil?.possuiBlocoCirurgico && (
                <div>
                  <p> - Bloco Cirúrgico </p>
                  {dadosPerfil?.quantasSalasDeCirurgia !== null && (
                    <div style={{ marginLeft: '20px', marginBottom: '10px' }}>
                      <h3>Quantas salas de cirurgia?</h3>
                      <p>{dadosPerfil?.quantasSalasDeCirurgia}</p>
                    </div>
                  )}
                </div>
              )}
              {/*  */}

              {dadosPerfil?.possuiCentroObstestrico && (
                <div>
                  <p> - Centro Obstétrico</p>
                  {dadosPerfil?.quantasSalasDeParto !== null && (
                    <div style={{ marginLeft: '20px', marginBottom: '10px' }}>
                      <h3>Quantas salas de parto?</h3>
                      <p>{dadosPerfil?.quantasSalasDeParto}</p>
                    </div>
                  )}
                </div>
              )}
              {/*  */}

              {dadosPerfil?.possuiUTI && (
                <p> - Unidade de Tratamento Intensivo Geral</p>
              )}
              {/*  */}

              {dadosPerfil?.possuiUnidadeTratamentoIntensivoEspecializada && (
                <div>
                  <p> - Unidade de Tratamento Intensivo Especializada</p>
                  {dadosPerfil?.utiEspecializada !== null && (
                    <div style={{ marginLeft: '20px', marginBottom: '10px' }}>
                      <h3>Quais especialidades?</h3>

                      <div>
                        {getItens(
                          'utiEspecializada',
                          dadosPerfil?.utiEspecializada
                        )
                          ?.sort((a, b) => (a?.posicao > b?.posicao ? 1 : -1))
                          ?.map((item, index) => {
                            const innerHtml = (
                              <span
                                dangerouslySetInnerHTML={createInnerHtml(
                                  item.nome
                                )}
                              />
                            );
                            return (
                              <p key={`${item.nome}-${index}`}>
                                {' '}
                                - {innerHtml}
                              </p>
                            );
                          })}
                      </div>
                    </div>
                  )}
                </div>
              )}
              {/*  */}

              <h3>Qual o grupo etário dos pacientes atendidos?</h3>
              {dadosPerfil?.atendeNeonatal && (
                <div>
                  <p> - Neonatal</p>

                  {dadosPerfil?.totalLeitoUTINeonatal !== null && (
                    <div style={{ marginLeft: '20px', marginBottom: '10px' }}>
                      <h3>Quanto leitos? </h3>
                      <p>{dadosPerfil?.totalLeitoUTINeonatal}</p>
                    </div>
                  )}

                  {dadosPerfil?.totalEnfermeirosUTINeonatal !== null && (
                    <div style={{ marginLeft: '20px', marginBottom: '10px' }}>
                      <h3> Quantos enfermeiros(as) por leito? </h3>
                      <p>{dadosPerfil?.totalEnfermeirosUTINeonatal}</p>
                    </div>
                  )}
                </div>
              )}

              {/*  */}

              {dadosPerfil?.atendePediatrico && (
                <div>
                  <p> - Pediátrico</p>

                  {dadosPerfil?.totalLeitoUTIPediatrico !== null && (
                    <div style={{ marginLeft: '20px', marginBottom: '10px' }}>
                      <h3>Quanto leitos? </h3>
                      <p>{dadosPerfil?.totalLeitoUTIPediatrico}</p>
                    </div>
                  )}

                  {dadosPerfil?.totalEnfermeirosUTIPediatrico !== null && (
                    <div style={{ marginLeft: '20px', marginBottom: '10px' }}>
                      <h3> Quantos enfermeiros(as) por leito? </h3>
                      <p>{dadosPerfil?.totalEnfermeirosUTIPediatrico}</p>
                    </div>
                  )}
                </div>
              )}

              {/*  */}

              {dadosPerfil?.atendeAdulto && (
                <div>
                  <p> - Adulto</p>

                  {dadosPerfil?.totalLeitoUTIAdulto !== null && (
                    <div style={{ marginLeft: '20px', marginBottom: '10px' }}>
                      <h3>Quanto leitos? </h3>
                      <p>{dadosPerfil?.totalLeitoUTIAdulto}</p>
                    </div>
                  )}

                  {dadosPerfil?.totalEnfermeirosUTIAdulto !== null && (
                    <div style={{ marginLeft: '20px', marginBottom: '10px' }}>
                      <h3> Quantos enfermeiros(as) por leito? </h3>
                      <p>{dadosPerfil?.totalEnfermeirosUTIAdulto}</p>
                    </div>
                  )}
                </div>
              )}

              {/*  */}
            </div>
          </ReportItem>
          {/* ./ 29. Unidades presentes na Instituição:  */}

          {/* 30. Quais os serviços de apoio o hospital possui?  */}
          <ReportItem>
            <h3>30. Quais os serviços de apoio o hospital possui?</h3>

            {dadosPerfil?.diagnosticoTerapeutico && (
              <div className="subItens">
                {getItens(
                  'diagnosticoTerapeutico',
                  dadosPerfil?.diagnosticoTerapeutico
                )
                  ?.sort((a, b) => (a?.posicao > b?.posicao ? 1 : -1))
                  ?.map((item, index) => {
                    const innerHtml = (
                      <span
                        dangerouslySetInnerHTML={createInnerHtml(item?.nome)}
                      />
                    );
                    return (
                      <div key={`${item}-${index}`}>
                        <p> - {innerHtml}</p>
                        {item?.nome === 'Hemodinâmica' &&
                          dadosPerfil?.atendimento24Hemodinamica !== null && (
                            <div
                              style={{
                                marginLeft: '20px',
                                marginBottom: '10px',
                              }}
                            >
                              <h3>
                                A unidade funciona 24 horas por dia e 7 dias da
                                semana?
                              </h3>
                              {responseBoolean(
                                dadosPerfil?.atendimento24Hemodinamica
                              )}
                            </div>
                          )}
                      </div>
                    );
                  })}
              </div>
            )}
          </ReportItem>
          {/* ./ 30. Quais os serviços de apoio o hospital possui?  */}

          {/*31. O Hospital pertence a algum grupo? */}
          <ReportItem>
          {validaRedeAssitencial(dadosPerfil)}
          {redeAssistencial === true ? (
              <h3><span style={{ color: 'red' }}>31. O Hospital pertence a algum grupo?</span></h3>
            ) : (<h3>31. O Hospital pertence a algum grupo?</h3>)
            }
            {responseBoolean(dadosPerfil?.redeAssistencial)}

            {dadosPerfil?.redeAssistencial && (
              <div className="subItens">
                <h3>Qual o CNPJ da matriz? </h3>
                
                <p>{dadosPerfil?.redeAssistencialCnpj} -<br/> {dadosPerfil?.redeAssistencialRazao} </p>
              </div>
            )}
          </ReportItem>
          {/* ./31. O Hospital pertence a algum grupo? */}
        </BoxReportItens>

        <BoxButton>
          {campObrigatorio === false && (
            <ButtonBase onClick={submitProfile}>Submeter Perfil</ButtonBase>
          )}
        </BoxButton>
      </Modal>
    </ReportDataProfileContainer>
  );
};

export default ReportDataProfile;
